import { Toast, ToastContainer, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/**
 * Centred, auto-hiding notice toast.
 *
 * Reads from the `useToast` hook values passed as props so it stays
 * a pure presentational component with no internal state.
 */
const NoticeToast = ({ show, message, missingFields = [], onClose }) => {
  const navigate = useNavigate();

  return (
    <ToastContainer
      className="p-3"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Toast onClose={onClose} show={show} delay={5000} autohide bg="warning" style={{ pointerEvents: "auto" }}>
        <Toast.Header>
          <strong className="me-auto">Notice</strong>
        </Toast.Header>
        <Toast.Body>
          <div style={{ marginBottom: "6px" }}>{message}</div>
          {missingFields.length > 0 && (
            <>
              <div style={{ fontWeight: "bold" }}>Missing:</div>
              <ul>
                {missingFields.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <Button variant="link" style={{ padding: 0 }} onClick={() => navigate("/profile")}>
                Complete Profile
              </Button>
            </>
          )}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default NoticeToast;
